export default function (suggestions = []) {
  return {
    active: true,
    query: '',
    filtered: [],
    focusedIndex: -1,

    get hasInput() {
      return this.query.length > 1;
    },

    filterResults() {
      if (this.query.trim() === '') {
        this.filtered = [];
        this.open = false;
        this.focusedIndex = -1;
        return;
      }
      const search = this.query.toLowerCase();
      this.filtered = suggestions.filter(item =>
        item.title.toLowerCase().includes(search)
      );
      this.open = true;
      this.focusedIndex = -1;
    },

    formatResult(item) {
      const index = item.title.toLowerCase().indexOf(this.query.toLowerCase());
      if (index === -1) return item.title;

      const parts = [
        `<span>${item.title.slice(0, index)}</span>`,
        `<span class="underline underline-offset-4 decoration-accent-1">${item.title.slice(index, index + this.query.length)}</span>`,
        `<span>${item.title.slice(index + this.query.length)}</span>`
      ];

      return parts.join('');
    },

    focusNext() {
      if (!this.open) return;
      this.focusedIndex = (this.focusedIndex + 1) % this.filtered.length;
    },

    focusPrev() {
      if (!this.open) return;
      this.focusedIndex = (this.focusedIndex - 1 + this.filtered.length) % this.filtered.length;
    },

    openList() {
      if (this.filtered.length > 0) {
        this.open = true;
      }
    },

    selectResult(result) {
      this.closeList();
      up.navigate({ url: result.url });
    },

    closeList() {
      this.open = false;
      this.focusedIndex = -1;

    },

    chooseFocused() {
      if (this.focusedIndex >= 0 && this.focusedIndex < this.filtered.length) {
        this.selectResult(this.filtered[this.focusedIndex]);
      }
    }
  };
}
